<template>
  <dt>
    <dl v-for="offer in this.offers" :key="offer.id">
      <BundleChoice :offer="offer" />
    </dl>
  </dt>
</template>

<script>
import BundleChoice from "@/components/BundleChoice";
import useBundleStore from '@/store/bundle'
import {mapState, mapWritableState} from 'pinia'

export default {
  name: 'App',
  components: {
    BundleChoice
  },
  computed: {
    ...mapWritableState(useBundleStore, ['productPrice', 'tax']),
    ...mapState(useBundleStore, ['setOffer', 'hasError']),
  },
  created () {
    window.addEventListener('tax-calculated', this.handleTaxCalcEvent)
  },
  methods: {
    handleTaxCalcEvent(event) {
      if (event.detail.offerId) {
        this.setOffer(event.detail.offerId, {
          "tax": event.detail?.tax
        })
      }
    }
  }
}
</script>

<style lang="scss">
#commerce-app {
  --default-font-stack: "Roboto", Helvetica, Arial, sans-serif;
  --condensed-font-stack: "Roboto Condensed", "Arial Narrow", "Roboto", Helvetica, Arial, sans-serif;
  --tmf-blue: rgb(0, 149, 199);
  --tmf-dk-blue: rgb(0, 32, 91);
  --tmf-yellow: rgb(251, 204, 85);
  --tmf-lt-yellow: rgb(255, 226, 154);
}
</style>
